import { STORAGE_KEY } from "../../../features/api/apiSlice";

const privateRoutes = [
  {
    path: "/dashboard",
    roles: [
      "admin",
      "member",
      "staff",
      "executive",
      "chairman",
      "secretary",
      "probationer",
      "student",
      "firm",
      "graduate",
      "technician",
      "fellow",
    ],
  },
  { path: "/procurement", roles: ["procurement", "admin"] },
  { path: "/logbook", roles: ["user", "staff", "admin"] },
  { path: "/events", roles: ["admin", "user", "staff"] },
  { path: "/databank", roles: ["admin", "user", "staff"] },
];

function normalizeRoles(input: any): string[] {
  if (!input) return [];
  if (!Array.isArray(input)) return [];
  return input
    .map((r) => (typeof r === "string" ? r : r?.name))
    .filter(Boolean);
}

// export function getDefaultRouteForUser(): string {
//   const raw = localStorage.getItem(STORAGE_KEY);
//   const auth = raw ? JSON.parse(raw) : null;

//   const roles = normalizeRoles(auth?.roles);

//   // If no roles, just go to dashboard
//   if (!roles.length) return "/dashboard";

//   // Find first allowed route
//   const match = privateRoutes.find((r) =>
//     r.roles.some((role) => roles.includes(role))
//   );

//   return match?.path || "/unauthorized";
// }

export const getDefaultRouteForUser = () => {
  const raw = localStorage.getItem(STORAGE_KEY);
  const user = raw ? JSON.parse(raw) : null;

  if (!user) return "/login";
  if (user?.whois != "admin") {
    if (!user.changed_password) {
      return "/change-password";
    }
    if (!user.updated_profile) {
      return "/complete-profile";
    }
  }

  // ✅ probationer must verify email first
  if (!user.email_verified_at) {
    return "/verify-email";
  }

  if (!user.application_fee) {
    return "/pay-application-fee";
  }

  // New applicants (not yet migrated users) must submit first application
  const needsApplication = ["probationer", "student", "technician", "graduate"].includes(
    user.whois
  );
  if (needsApplication && !user.has_application) {
    return "/first-application";
  }

  const roles = normalizeRoles(user?.roles);

  // If no roles, just go to dashboard
  if (!roles.length) return "/dashboard";

  // Find first allowed route
  const match = privateRoutes.find((r) =>
    r.roles.some((role) => roles.includes(role))
  );

  return match?.path || "/dashboard";
};
